module.exports = __webpack_public_path__ + "static/media/ASUTmanual.526db5a8.pdf";